export default __webpack_public_path__ + "static/facial_men-bdeecbffaa1de5d9acfec42d239dff57.jpg";